module.exports = __webpack_public_path__ + "static/media/titulo_criculo nuitmental.3ef2398a.png";